import * as c from '../helpers/constants';
import { getToken, isAuthenticated } from '../store/auth';

const constants = {
    NEW_TEMPLATE: 'NEW_TEMPLATE',

    SAVE_EDITOR: 'SAVE_EDITOR',

    SAVE_TEMPLATE_REQUEST: 'SAVE_TEMPLATE_REQUEST',
    SAVE_TEMPLATE_SUCCESS: 'SAVE_TEMPLATE_SUCCESS',
    SAVE_TEMPLATE_FAILURE: 'SAVE_TEMPLATE_FAILURE',

    SAVE_ARQUIVO_TEMPLATE_REQUEST: 'SAVE_ARQUIVO_TEMPLATE_REQUEST',
    SAVE_ARQUIVO_TEMPLATE: 'SAVE_ARQUIVO_TEMPLATE',
    SAVE_ARQUIVO_TEMPLATE_FAILURE: 'SAVE_ARQUIVO_TEMPLATE_FAILURE',
}

const initialState = {
    editor: undefined,
    template: undefined,
    exception: undefined
}

export const templateAction = {
    salvarEditor: (editor) => async (dispatch, getState) => {
        dispatch({ type: constants.SAVE_EDITOR, tipo: editor });
    },

    salvarIdArquivoTemplate: (idArquivo) => async (dispatch, getState) => {
        dispatch({ type: constants.SAVE_ARQUIVO_TEMPLATE, idArquivoTemplate: idArquivo });
    },

    salvarTemplateCarimbo: (form, status) => async (dispatch, getState) => {

        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        let template = {
            id: form.id,
            mensagem: form.mensagem,
            campanha: { id: form.campanha.id }
        };
        const url = `${c.API_BASE_URL}/template-carimbo-tempo/${form.id}`;
        const options = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': _token },
            body: JSON.stringify(template)
        };

        dispatch({ type: constants.SAVE_TEMPLATE_REQUEST });

        return fetch(url, options).then(async (response) => {
            let json = await response.json();
            if (!response.ok) throw (json);
            return json;

        }).catch((exception) => {
            dispatch({ type: constants.SAVE_TEMPLATE_FAILURE, exception: exception }); throw (exception);
        });
    },

    salvarTemplate: (form, editor, idArquivoTemplate) => async (dispatch, getState) => {

        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        let template = {
            id: form.id,
            nome: form.nome,
            mensagem: form.mensagem,
            editor: editor,
            idEmpresa: form.empresa.id,
            idArquivo: idArquivoTemplate,
        };

        const url = `${c.API_CAMPAIGN_URL}/template`;
        const options = {
            method: 'POST'
            , headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            , body: JSON.stringify(template)
        };

        dispatch({ type: constants.SAVE_TEMPLATE_REQUEST });

        return fetch(url, options).then(async (response) => {
            let json = await response.json();
            if (!response.ok) throw (json);
            return json;

        }).catch((exception) => {
            dispatch({ type: constants.SAVE_TEMPLATE_FAILURE, exception: exception }); throw (exception);
        });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.key) {
        case constants.SAVE_EDITOR:
            return {
                ...state,
                editor: { isSubmitted: true, type: action.tipo }
            };

        case constants.SAVE_TEMPLATE_REQUEST:
            return {
                ...state,
                template: {},
            };

        case constants.SAVE_TEMPLATE_SUCCESS:
            return {
                ...state,
                template: { isSubmitted: true, form: action.form }
            };

        case constants.SAVE_TEMPLATE_FAILURE:
            return {
                ...state,
                template: {},
                exception: action.exception,
            };

        case constants.SAVE_ARQUIVO_TEMPLATE:
            return {
                ...state,
                arquivoTemplate: { isSubmitted: true, idArquivoTemplate: action.idArquivoTemplate },
            };

        default:
            return state;
    }
}